module.exports = __webpack_public_path__ + "img/1561300039.d7df2a5b.jpg";